import Header from "./Header";
import TableLicenses from "./TableLicenses";
import TableExplore from "./TableExplore";
import Login from "./Login";

const Content = ({ page, itemList, exploreList, purchaseButtonClick, address, ethereumButton }) => {
    return(
        <div className="flex-grow border-l-2 border-white text-white bg-neutral-800	">
            <Header sectionName={page}/>
            <div style={{ marginLeft: '10px' }}></div>
            {page === "Explore" ? <TableExplore itemList={exploreList} purchaseButtonClick={purchaseButtonClick} /> :
            page === "My Licenses" && address === null? <Login ethereumButton={ethereumButton}/> : page === "My Licenses" && address !== null?  <TableLicenses itemList={itemList} /> : <div></div>}
        </div>
    );
}

export default Content;